function setStyleElementText(element, text) {
    if ("styleSheet" in element) {
        element["styleSheet"].cssText = text;
    }
    else {
        element.innerText = "";
        element.appendChild(document.createTextNode(text));
    }
}
export default setStyleElementText;
